import { render, staticRenderFns } from "./Utenze.vue?vue&type=template&id=802686f0&"
import script from "./Utenze.vue?vue&type=script&lang=js&"
export * from "./Utenze.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports